import { useTranslation } from "react-i18next";
import { Briefcase, User } from "lucide-react";
import { useDirtyGuard } from "../../context/DirtyGuard";
import { EmployeeFormSection } from "./EmployeeFormSection";
import { EmployeeFormActions } from "./EmployeeFormActions";
import { EmployeeJobFields } from "./EmployeeJobFields";
import { EmployeePersonalFields } from "./EmployeePersonalFields";
import { useEmployeeForm } from "./useEmployeeForm";
import { countryRule, useCountries } from "./useCountries";
import { hasErrors, personalErrors } from "./idValidate";

// نموذج تعديل الموظف بتصميم احترافي متجاوب: قسمان + شريط أوامر لاصق.
export const EmployeeForm = ({ initial, branches, onSaved, onCancel }) => {
  const { t } = useTranslation();
  const { form, busy, submit, persist, setField, setPersonal, toggleBranch, dirty } = useEmployeeForm(initial, onSaved);
  const countries = useCountries();
  const rule = countryRule(countries, form.personal.nationality);
  const errors = personalErrors(form.personal, rule);
  const invalid = hasErrors(errors);
  useDirtyGuard(dirty && !invalid, persist);

  return (
    <form className="grid gap-5" onSubmit={submit} data-testid="employee-form">
      <EmployeeFormSection
        icon={Briefcase}
        tone="primary"
        title={t("employees.form.jobTitle")}
        hint={t("employees.form.jobHint")}
        cols={3}
        testId="employee-form-job"
      >
        <EmployeeJobFields form={form} setField={setField} branches={branches} toggleBranch={toggleBranch} userId={initial?.id} />
      </EmployeeFormSection>

      <EmployeeFormSection
        icon={User}
        tone="indigo"
        title={t("personal.title")}
        hint={t("personal.countryNote")}
        cols={3}
        testId="employee-form-personal"
      >
        <EmployeePersonalFields
          personal={form.personal}
          setPersonal={setPersonal}
          countries={countries}
          rule={rule}
          errors={errors}
        />
      </EmployeeFormSection>

      <EmployeeFormActions busy={busy} invalid={invalid} dirty={dirty} onCancel={onCancel} />
    </form>
  );
};
